export default {
  DRAFT: 'DRAFT',
  SENT: 'SENT',
  UNPAID: 'UNPAID',
  PAID: 'PAID',
  PENDING: 'PENDING',
  PARTIALLY_PAID: 'PARTIALLY_PAID',
  CANCELLED: 'CANCELLED'
}